import { ApprovalStatus } from '@cdaas/api-clients/dist/order-openapi';
import { getPendingApprovalChains } from './apiRequest';
import { getActiveOrganizationId } from './authUtils';

export enum ApprovalFilterEnum {
  Approved = 'Approved',
  PendingApproval = 'PendingApproval',
  Rejected = 'Rejected',
}

export const getAvailabilityColor = (status: string): 'green500' | 'orange500' | 'red600' => {
  switch (status) {
    case 'Approved':
      return 'green500';
    case 'PendingApproval':
      return 'orange500';
    case 'Rejected':
      return 'red600';
    default:
      return 'red600';
  }
};

export const getNumberOfPendingApprovals = async (): Promise<number | null> =>
  getPendingApprovalChains(getActiveOrganizationId(), 1).then(response => {
    return response?.page_metadata.total_items || null;
  });

export const handleApprovalStatusMappingToFrontendEnum = (status: ApprovalStatus): ApprovalFilterEnum => {
  switch (status) {
    case ApprovalStatus.NotNeeded:
      return ApprovalFilterEnum.Approved;
    case ApprovalStatus.AutoApproved:
      return ApprovalFilterEnum.Approved;
    case ApprovalStatus.Approved:
      return ApprovalFilterEnum.Approved;
    case ApprovalStatus.Pending:
      return ApprovalFilterEnum.PendingApproval;
    case ApprovalStatus.Rejected:
      return ApprovalFilterEnum.Rejected;
  }
};
